"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFirebaseApp = exports.FirebaseProvider = void 0;
const app_1 = require("firebase/app");
const react_1 = __importStar(require("react"));
const environment_1 = require("../environment");
const FirebaseContext = (0, react_1.createContext)(undefined);
/**
 * Initializes Firebase and provides it via context.
 */
const FirebaseProvider = (props) => {
    return (react_1.default.createElement(FirebaseContext.Provider, { value: (0, app_1.initializeApp)((0, environment_1.getEnv)().firebaseConfig) }, props.children));
};
exports.FirebaseProvider = FirebaseProvider;
/**
 * Returns the Firebase context.
 */
function useFirebaseApp() {
    const context = (0, react_1.useContext)(FirebaseContext);
    if (context === undefined) {
        throw new Error("useFirebase must be used within a FirebaseProvider");
    }
    return context;
}
exports.useFirebaseApp = useFirebaseApp;
